var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container flow" },
    [
      _c(
        "fieldset",
        [
          _vm._l(_vm.$v.overige.rekening.$each.$iter, function(
            rekening,
            key,
            index
          ) {
            return _c(
              "div",
              { key: "rekInput-" + key },
              [
                _c("iban-input", {
                  attrs: {
                    id: "rekening-iban-" + key,
                    label:
                      _vm.overige.rekening.length === 1
                        ? _vm.labels.rekening.iban
                        : _vm.labels.rekening.iban + " " + (index + 1),
                    "is-dirty": _vm.isDiffToCache(
                      _vm.overige.rekening[key].iban,
                      _vm.cache.rekening[key].iban
                    ),
                    "is-new": index >= _vm.cache.rekening.length,
                    "validation-object": rekening.iban,
                    "is-disabled": _vm.disabledFieldsMap.rekening,
                    info: _vm.infoForInput("rekening"),
                    "show-delete": index !== 0
                  },
                  on: {
                    "delete-iban": function($event) {
                      return _vm.overige.rekening.splice(index, 1)
                    }
                  },
                  model: {
                    value: rekening.$model.iban,
                    callback: function($$v) {
                      _vm.$set(rekening.$model, "iban", $$v)
                    },
                    expression: "rekening.$model.iban"
                  }
                }),
                _vm._v(" "),
                _c("bic-input", {
                  attrs: {
                    label:
                      _vm.overige.rekening.length !== 1
                        ? _vm.labels.rekening.bic + " " + (index + 1)
                        : _vm.labels.rekening.bic,
                    id: "rekening-bic-" + key,
                    "is-dirty": _vm.isDiffToCache(
                      _vm.overige.rekening[key],
                      _vm.cache.rekening[key]
                    ),
                    "validation-object": rekening.bic,
                    "is-disabled": _vm.disabledFieldsMap.rekening
                  },
                  model: {
                    value: rekening.$model.bic,
                    callback: function($$v) {
                      _vm.$set(rekening.$model, "bic", $$v)
                    },
                    expression: "rekening.$model.bic"
                  }
                })
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.hiddenFieldsMap.rijbewijs
            ? _c("yes-no-input", {
                attrs: {
                  id: "pLidEditingRijbewijs",
                  name: "rijbewijsRadio",
                  label: _vm.labels.rijbewijs,
                  "is-disabled": _vm.disabledFieldsMap.rijbewijs,
                  info: _vm.infoForInput("rijbewijs"),
                  "is-dirty":
                    _vm.overige.mobiliteit.rijbewijs !==
                    _vm.cache.mobiliteit.rijbewijs
                },
                model: {
                  value: _vm.overige.mobiliteit.rijbewijs,
                  callback: function($$v) {
                    _vm.$set(_vm.overige.mobiliteit, "rijbewijs", $$v)
                  },
                  expression: "overige.mobiliteit.rijbewijs"
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("fieldset", [
        _c("h5", [_vm._v("Nummerplaten")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flow", staticStyle: { "--flow-space": "2rem" } },
          _vm._l(_vm.$v.overige.mobiliteit.nummerplaten.$each.$iter, function(
            nummerplaat,
            key,
            index
          ) {
            return _c(
              "div",
              { key: "nummerplaat-" + key },
              [
                _c("text-input", {
                  attrs: {
                    id: "nummerplaat-" + key,
                    label: _vm.labels.nummerplaat + " " + (index + 1),
                    "is-disabled":
                      _vm.disabledFieldsMap.nummerplaten ||
                      nummerplaat.$model.id !== 0,
                    "is-dirty": _vm.isDiffToCache(
                      _vm.overige.mobiliteit.nummerplaten[parseInt(index)],
                      _vm.cache.mobiliteit.nummerplaten[index]
                    ),
                    "validation-object": nummerplaat.nummerplaat
                  },
                  model: {
                    value: nummerplaat.$model.nummerplaat,
                    callback: function($$v) {
                      _vm.$set(nummerplaat.$model, "nummerplaat", $$v)
                    },
                    expression: "nummerplaat.$model.nummerplaat"
                  }
                }),
                _vm._v(" "),
                !_vm.disabledFieldsMap.nummerplaten
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm-3" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-9" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-outline-dark",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.deleteNummerplaat(index)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: ["far", "trash-alt"], size: "s" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "pr-1" }, [
                              _vm._v("Verwijderen")
                            ])
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center my-3 pb-3" },
        [
          _c("plus-button", {
            attrs: {
              label: "Nummerplaat toevoegen",
              disabled: _vm.disabledFieldsMap.nummerplaten
            },
            on: {
              click: function($event) {
                return _vm.addNummerplaat()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.hiddenFieldsMap.orcid
        ? _c(
            "fieldset",
            [
              _c("text-input", {
                attrs: {
                  id: "idForOrcid",
                  maxLength: 19,
                  label: _vm.labels.orcid,
                  "is-dirty": _vm.overige.orcid !== _vm.cache.orcid,
                  info: _vm.infoForInput("orcid"),
                  "is-disabled": _vm.disabledFieldsMap.orcid,
                  "validation-object": _vm.$v.overige.orcid
                },
                model: {
                  value: _vm.$v.overige.orcid.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.overige.orcid, "$model", $$v)
                  },
                  expression: "$v.overige.orcid.$model"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pt-2 mt-3 border-top" }, [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v("Opmerking:")
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentRemark,
              expression: "currentRemark"
            }
          ],
          staticClass: "form-control mb-2",
          attrs: { rows: "3", placeholder: "Opmerking", type: "text" },
          domProps: { value: _vm.currentRemark },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentRemark = $event.target.value
              },
              _vm.onRemarkChange
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("file-upload", {
        attrs: { label: "Bewijsstuk(ken) uploaden:", "upload-percentage": 0 },
        on: { "files-changed": _vm.onFilesChanged }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }